const AREASLIST = [
  ' AJMAN,NUAIMIYA ',
  ' AL BARAHA',
  ' DMCC',
  ' MUROOR-ABU DHABI',
  ' SHARAF DG ',
  '12',
  '12323',
  '7, Abu Dhabi',
  'ABHU DHABI',
  'ABHUDABI',
  'ABHUDABI ',
  'ABU DHABHI',
  'ABU DHABI',
  'ABU DHABI - M 36',
  'ABU DHABI MAFRAQ',
  'ABU DHABI, M - 11',
  'ABU DHABI,CORNICHE',
  'ABU DHABI,ELECTRA',
  'ABU DHABI,M36',
  'ABU DHABI-AIRPORT',
  'ABU DHABI-M35',
  'ABU HAIL',
  'ABU HAIL MALL',
  'ABU HAIL, DEIRA',
  'ABU SAGAR',
  'ABU SHAGARA',
  'ABU SHAGARA, SHARJAH',
  'ABU SHAGHARA',
  'ABU-BAKER-SIDDIQUE',
  'ABUDABI',
  'ABUDHABI',
  'ADEN',
  'ADEN, RAS AL KHAIMA',
  'ADHEN, RAK',
  'ADHEN,RAK',
  'AIRPORT ROAD',
  'AIRPORT ROAD,  AUH',
  'AIRPORT ROAD, AUH',
  'AJAMAN INDUSTRIAL 2',
  'AJBAN, AUH',
  'AJM RASSIDIYYA- 3',
  'AJM-GOLD SOUQ',
  'AJM-NAKHIL RUMILA',
  'AJMAN',
  'AJMAN ',
  'AJMAN - AL JERF 2',
  'AJMAN AL BUSTAN',
  'AJMAN AL RAWDAA',
  'AJMAN DUSTHAN',
  'AJMAN IND',
  'AJMAN INDUSTRIAL -1',
  'AJMAN INDUSTRIAL -2',
  'AJMAN INDUSTRIAL 2',
  'AJMAN INDUSTRIL 1',
  'AJMAN INDUSTRIL 2',
  'AJMAN JARAF - 1',
  'AJMAN JURF',
  'AJMAN JURF 3',
  'AJMAN LIWARA',
  'AJMAN MUWAIHAT',
  'AJMAN NAKHEEL',
  'AJMAN NUAIMAI',
  'AJMAN NUAIMAI - ',
  'AJMAN NUAIMAI - 1',
  'AJMAN NUAIMAI - 2',
  'AJMAN NUAIMAI- 02',
  'AJMAN NUAIMAI- 03',
  'AJMAN RASSIDIYYA- 1',
  'AJMAN RASSIDIYYA- 3',
  'AJMAN SANAYA',
  'AJMAN SANAYA - 1',
  'AJMAN SANAYA - 2',
  'AJMAN, BUSTAN',
  'AJMAN, GOLD SOUQ',
  'AJMAN, HAMIDIYA',
  'AJMAN, HELIO',
  'AJMAN, INDUSTRIAL - 1',
  'AJMAN, INDUSTRIAL - 2',
  'AJMAN, INDUSTRIAL - 3',
  'AJMAN, JURF',
  'AJMAN, JURF - 3',
  'AJMAN, KARAMA',
  'AJMAN, LINARA - 02',
  'AJMAN, Lucky',
  'AJMAN, MUWAIHAT',
  'AJMAN, MUWAYATH - 1',
  'AJMAN, NAKHEEL',
  'AJMAN, NAKHEEL - 2',
  'AJMAN, NAKHEEL RUMAILA - 1',
  'AJMAN, NUAIMIA',
  'AJMAN, NUAIMIA ',
  'AJMAN, NUAIMIA - 1',
  'AJMAN, NUAIMIA - 2',
  'AJMAN, NUAIMIA -1',
  'AJMAN, NUAIMIA -2',
  'AJMAN, NUAIMIA -3',
  'AJMAN, RAMADHA - 2',
  'AJMAN, RASHIDIYA',
  'AJMAN, RASHIDIYA - 1',
  'AJMAN, RASHIDIYA - 2',
  'AJMAN, RASHIDIYA - 3',
  'AJMAN, RASIDIYA - 3',
  'AJMAN, RAWDA',
  'AJMAN, RAWDHA - 2',
  'AJMAN, RUMAILA',
  'AJMAN, RUMAILA - 1',
  'AJMAN, SANAYA',
  'AJMAN, SANAYA - 1',
  'AJMAN, SANAYA - 2',
  'AJMAN, SANAYA - 3',
  'AJMAN, Sanayya',
  'AJMAN, VEGETABLES MARKET',
  'AJMAN, ZAHYA',
  'AJMAN,BUSTAN',
  'AJMAN,GOLD-SOUQ',
  'AJMAN,HAMIDIYA-2',
  'AJMAN,HELIO',
  'AJMAN,INDUSTRIAL -2',
  'AJMAN,INDUSTRIAL-1',
  'AJMAN,INDUSTRIAL-2',
  'AJMAN,JURF',
  'AJMAN,JURF INDUSTRIAL-1',
  'AJMAN,JURF INDUSTRIAL-2',
  'AJMAN,JURF-1',
  'AJMAN,JURF-2',
  'AJMAN,JURF-3',
  'AJMAN,JURF-INDUSTRIAL ',
  'AJMAN,KARAMA',
  'AJMAN,MOWAIHAT-3',
  'AJMAN,MUSHAIREF',
  'AJMAN,NAKHEEL',
  'AJMAN,NAKHEEL-1',
  'AJMAN,NUAIMIYA-1',
  'AJMAN,NUAIMIYA-2',
  'AJMAN,NUAIMIYA-3',
  'AJMAN,RASHIDIYA',
  'AJMAN,RASHIDIYA-1',
  'AJMAN,RASHIDIYA-2',
  'AJMAN,RASHIDIYA-3',
  'AJMAN,RAWDA',
  'AJMAN,RAWDA-1',
  'AJMAN,RAWDA-2',
  'AJMAN,RAWDA-3',
  'AJMAN,RUMAILA',
  'AJMAN,RUMAILA-2',
  'AJMAN,SANAYA-2',
  'AJMAN,SANAYA-LAKI',
  'AJMAN,VEGITABLES MARKET',
  'AJMAN-JARAF',
  'AJMAN-JARAF 2',
  'AJMAN-JARF 1',
  'AJMAN-NUYMIYA',
  'AJMAN-NUYMIYA 1',
  'AJMAN-RAWDHA',
  'AJMAN-RAWDHA 2',
  'AJMAN-SANAYYA 2',
  'AL AIN',
  'AL AIN ',
  'AL AIN ,TWON CENTER',
  'AL AIN, AUH',
  'AL AIN, SANAYA',
  'AL ATHBAH',
  'AL AWEER',
  'AL AWEER- 2',
  'AL AWIR-2',
  'AL BADA, DUBAI',
  'AL BAHIA',
  'AL BARAHA',
  'AL BARSHA',
  'AL BARSHA - 1',
  'AL BARSHA 2',
  'AL BARSHA-1',
  'AL BUSTAN',
  'AL BUSTAN AJMAN',
  'AL DAFRA, ABU DHABI',
  'AL DANAH, AUH',
  'AL DHAFRA,AUH',
  'AL DHAID',
  'AL DIGDAGA, RAK',
  'AL FAHIDI',
  'AL FALAH ST, AUH',
  'AL FALAH, ABU DHABI',
  'AL FALAH, AUH',
  'AL FALAYAH (RAK)',
  'AL FASEEL-FJH',
  'AL FLAYA',
  'AL FOAH, AL AIN',
  'AL FOHA',
  'AL FURJAN',
  'AL GARHOUD',
  'AL GHAIL, RAK',
  'AL GHAIL,RAK',
  'AL GHUBAIBA',
  'AL GHUIL',
  'AL HAIL',
  'AL HAIL-FUJAIRAH',
  'AL HAMRAH (RAK)',
  'AL HAMRIYA',
  'AL HAYER',
  'AL HELIOW 1',
  'AL HIYAR',
  'AL HUDAIBA',
  'AL JAFFILIYA',
  'AL JUWAIS, RAK',
  'AL KARAMA',
  'AL KHALIDIYA-ABU DHABI',
  'AL KHAN, SHARJAH',
  'AL KHAWANEEJ',
  'AL MAFRAQ, ABU DHABI',
  'AL MAMOORAH',
  'AL MIZHAR-2',
  'AL MURAR',
  'AL MUTAINAH',
  'AL MUTEENA',
  'AL NABBA, SHARJAH',
  'AL NAD-SHARJAH',
  'AL NADA',
  'AL NADA 2 DUBAI',
  'AL NADHA',
  'AL NADHA 1',
  'AL NADHA 2',
  'AL NADHA,SHARJAH',
  'AL NAHDA',
  'AL NAHDA - 2',
  'AL NAHDA 1',
  'AL NAHDA METRO',
  'AL NAHDA NMC',
  'AL NAHDA, SHARJAH',
  'AL NAHDA-2,SHARJAH',
  'AL NAHDA.2',
  'AL NAHDAH, SHARJAH',
  'AL NAHYAN',
  'AL NAHYAN, AUH',
  'AL NAKHEEL,RAK',
  'AL NOUDH',
  'AL NUAIMIA 1',
  'AL QIYADAH',
  'AL QOUZ',
  'AL QOUZ IND-1',
  'AL QOUZ-1',
  'AL QUOZ',
  'AL QUOZ - 01',
  'AL QUOZ - 02',
  'AL QUOZ - 03',
  'AL QUOZ - 04',
  'AL QUOZ - 1',
  'AL QUOZ 1ST',
  'AL QUOZ IND 2ND',
  'AL QUSAIS',
  'AL QUSSAIDAT,RAK',
  'AL QUWA',
  'AL RAFA, JAZEERAH',
  'AL RAFFA-UAQ',
  'AL RAS, DEIRA',
  'AL RASHIDIYA',
  'AL RASHIDIYA-2',
  'AL RIGGA',
  'AL SABKHA',
  'AL SABKHA,NAIF',
  'AL SEWAAN,RAK',
  'AL SHAAM, RAS AL KHAIMA',
  'AL SHAMAL, RAK',
  'AL SUFOUH',
  'AL TAWAN, SHARJAH',
  'AL TAWAR',
  'AL TAWAR 1',
  'AL TAWEEN',
  'AL WADAH, AUH',
  'AL WAGAN, AL AIN',
  'AL WAHEDA',
  'AL WARQA',
  'AL WARZAN',
  'AL YAHAR, AUH',
  'AL YASEER ',
  'AL ZAHIYA, AUH',
  'AL ZAHIYAH, E - 16',
  'ALAIN',
  'ALAIN, SANAYA',
  'ALAW, AUH',
  'ALFALAH,AUH',
  'ALIYAHAR',
  'ALMAKTUM,DUBAI',
  'ALNAHDA-1',
  'ALNAHDA-1,DUBAI',
  'ALQUOZ',
  'ALQUZ',
  'ARJAN',
  'ARJAN-DUBAI',
  'AUH',
  'AWEER',
  'Abu Dhabi',
  'Abu Hail',
  'Abu hail',
  'Ajman',
  'Al AIN,  HILI  SANAYYA',
  'Al Aweer',
  'Al BARAHA',
  'Al FAHIDI',
  'Al Garhoud',
  'Al Nahda 2',
  'Al QUOZ',
  'Al QUSAIS',
  'Al Quoz',
  'Al Quoz 4',
  'Al Qusais',
  'Al Qusais 2',
  'Al RIGGA',
  'Al Rashidiya, Dubai',
  'Al Shabhat, أبوظبي',
  'Al nada',
  'Alain',
  'Aweer',
  'BADA ZAYED',
  'BADA ZAYED, SANAYA',
  'BANIYAS',
  'BANIYAS SQUARE',
  'BANIYAS SQUARE, DXB',
  'BIDIYA',
  'BODA ZAYED, SANAYYA',
  'BU SHAGHARA',
  'BUR DUBAI',
  'BUR-DUBAI',
  'BURDUBAI',
  'BURJUMAN',
  'BUSINESS BAY',
  'BUSTAN',
  'BUSTAN AJMAN',
  'BUTINA, SHARJAH',
  'Batha Al Hayer, Al Ain',
  'CALICUT',
  'CALICUTBB',
  'CENTRAL MARKET, AL AIN ',
  'CHCHCHV',
  'CHINA,IC',
  'CITY CENTER-SHARJAH',
  'CORNICH, AUH',
  'CORNICHE,RAK',
  'CORNISH, RAK',
  'DAHAN',
  'DAHAN, RAK',
  'DAHAN,RAK',
  'DAMAC,CANAL VIEW',
  'DEFENCE ROAD : ABD, AUH',
  'DEFENCE ROAD, AUH',
  'DEFENCE ROAD-ABU DHABI',
  'DEIRA',
  'DEIRA, AL RAS',
  'DEIRA, BANIYAS',
  'DEIRA, DXB',
  'DEIRA, FIRJ AL MURAR',
  'DEIRA, GOLD SOUK',
  'DEIRA, NAIF',
  'DEIRA, NAKHEEL',
  'DELMA STR, ABUDHABI',
  'DHADNA',
  'DHAHAN, RAS AL KHAIMA',
  'DHAITH RASALAKAIMHA',
  'DIBBA',
  'DIBBA AL FUJAIRAH',
  'DIBBA,FUJ',
  'DIBBA-FUJAIRAH',
  'DIC',
  'DIDHNA',
  'DIGDAGA AIRPORT ROAD 052',
  'DIGDAGA, RAK',
  'DIGDAGA,RAK',
  'DIP',
  'DIP - 1',
  'DIP - 2',
  'DIP 1',
  'DIP 2',
  'DIP-1',
  'DIP-2',
  'DISCOVERY GARDEN',
  'DMCC FREEZONE',
  'DRAGON MART',
  'DRAGON MART, IC',
  'DRAGON MART,IC',
  'DUBAI',
  'DUBAI LAND, DXB',
  'DUBAI, AL NAHDA - 1',
  'DUBAI, AL NAHDA - 2',
  'DUBAI, DIP',
  'DUBAI, HAMRIYA',
  'DXB',
  'Deira, Dubai',
  'Deira, Gold Souk',
  'Delhi',
  'Dubai',
  'ECNOMIC TOURISM, AJMAN',
  'ELECTRA',
  'ELECTRA , AUH',
  'ELECTRA -ABD',
  'ELECTRA ST, AUH',
  'ELECTRA, ABU DHABI',
  'ELECTRA, AUH',
  'ELECTRA,AUH',
  'ELECTRA: ABD, AUH',
  'EMRIATES CITY, AJMAN',
  'ENGLAND-X,IC',
  'ENGLAND-XIC',
  'ENGLAND-Y,IC',
  'ENGLAND-Y,IC ',
  'Emirates City, AJMAN',
  'FALAJ AL MUALLA',
  'FALAJ AL MUALLA, UAQ',
  'FALAJ AL MULLA',
  'FASEEL',
  'FGUKK',
  'FIQAIT-FUJAIRAH',
  'FIRJ AL MURAR',
  'FIRJ AL MURAR-DEIRA',
  'FRANCE,IC',
  'FRANEE,IC',
  'FREEJ AL MURAR',
  'FREEJ-AL-MURAR',
  'FREEZONE-HAIL',
  'FRIJ AL  MURAR',
  'FRIJ AL MURAR',
  'FRIJ AL MURAR, DXB',
  'FRIJ MURAR',
  'FRIJ MURAR, DXB',
  'FUJAIRAH',
  'FUJAIRAH, THOBAN',
  'FVVHJ',
  'GARAYA',
  'GARDENS',
  'GGHHH',
  'GHAYATI SANAIYA',
  'GHJJJ',
  'GIDFA',
  'GOLD SOUQ',
  'GOLD SOUQ, AJMAN',
  'GOLD SOUQ, DXB',
  'GOLD SOUQ, RAK',
  'GOLD SOUQ,DEIRA',
  'GREECE, IC',
  'GREECE,IC',
  'HAIL',
  'HAMADAN ST',
  'HAMARIYA',
  'HAMDAN',
  'HAMDAN - ABU DHABI',
  'HAMDAN - AUH',
  'HAMDAN 5, AUH',
  'HAMDAN : ABU DHABI',
  'HAMDAN ST, AUH',
  'HAMDAN STREET',
  'HAMDAN, AUH',
  'HAMDAN,AUH',
  'HAMEEM',
  'HAMIDIYA 1',
  'HAMIDIYA-1,AJMAN',
  'HAMRANIYA',
  'HAMRANIYA,DUBAI',
  'HAMRANIYA,RAK',
  'HAMRIYA',
  'HAMRIYA, RAK',
  'HASSAN DIBBA',
  'HATTA',
  'HAZZ BIN ZAYED, AUH',
  'HCUCC',
  'HELIO, AJMAN',
  'HELLOW, AJMAN',
  'HFUC466',
  'HILI SANAYA',
  'HOR AL ANZ',
  'HSHSHSH',
  'HUDAIBA',
  'HUMAIDEYA 1',
  'Hay Al Qasimiah, Sharjah',
  'Hor Al Anz',
  'Hudaiba',
  'IC',
  'ICAD 1, AUH',
  'INDIA',
  'INDUS-2 , AJMAN',
  'INDUSTRIAL - 6,SHARJAH ',
  'INDUSTRIAL 1',
  'INDUSTRIAL 1, AJMAN',
  'INDUSTRIAL 10, SHJ',
  'INDUSTRIAL 2',
  'INDUSTRIAL AREA',
  'INDUSTRIAL AREA 1',
  'INDUSTRIAL AREA AJMAN',
  'INTER NATIONAL CITY',
  'INTERNATION CITY',
  'INTERNATIONAL  CITY',
  'INTERNATIONAL CITY',
  'INTERNATIONAL CITY\t',
  'INTERNATIONAL CITY ',
  'INTERNATIONAL CITY 1',
  'INTERNATIONAL CITY-2',
  'ITALY,IC',
  'ITALY,IC ',
  'Industrial 2',
  'Industrial Area, Sharjah',
  'International City',
  'JABAL ALI',
  'JABEL ALI',
  'JABEL ALI, FREE ZONE',
  'JADAF DUBAI',
  'JADDAF',
  'JAFELIYA',
  'JAFFILIYA',
  'JAFILEYA',
  'JAFILIYA',
  'JAZEERA',
  'JAZEERA FREEZONE, RAK',
  'JAZEERA, RAK',
  'JAZEERAH-RAK',
  'JEBAL ALI',
  'JEBAL ALI 1',
  'JEBEL ALI',
  'JULAN',
  'JULAN, RAK',
  'JULAN,RAK',
  'JUMEIRA-1',
  'JUMEIRAH',
  'JUMEIRAH 1',
  'JUMEIRAH-1',
  'JURF',
  'JURF 1',
  'JURF 2',
  'JURF 3',
  'JURF AJMAN',
  'JURF IND-03',
  'JURF INDUSTRIAL 1',
  'JURF, AJMAN',
  'JURF-2, AJMAN',
  'JURF-3, AJMAN',
  'JVC',
  'Jebal Ali',
  'Jurf 3',
  'Jurf Industrial 2',
  'Jurf Industrial Zone2',
  'KALBA',
  'KALBA, SHARJAH',
  'KALIDIYA, ABU DHABI',
  'KALIFA, AUH',
  'KARAAN, RAK',
  'KARAMA',
  'KARAMA STR : ABU DHABI',
  'KARAMA, AJMAN',
  'KARAN',
  'KARRAN, RAS AL KHAIMA',
  'KAWANEEJ',
  'KERALA',
  'KHALIDIYA, ABU DHABI',
  'KHALIDIYAH, AUH',
  'KHALIDIYAH,AUH',
  'KHALIFA CITY',
  'KHALIFA, AUH',
  'KHARAN, RAK',
  'KHAT, RAK',
  'KHAT, RAS AL KHAIMA',
  'KHAT, RAS AL KHAIMAH',
  'KHAWANEEJ',
  'KHAWANEEJ - 2',
  'KHUZAM, RAK',
  'KM TRADING - 34',
  'KORFUKAN',
  'KORFUKAN-FUJAIRAH',
  'KUWAIT ROAD, RAK',
  'KUZHAM',
  'Karama',
  'LAHBAB-DUBAI',
  'LISAIL',
  'LISAILI',
  'LISALI',
  'LIWARA 1',
  'LIWARA, AJMAN',
  'LIWARA-1',
  'LIWARA-2',
  'LOCAL',
  'LULUYA',
  'M12, Abu Dhabi',
  'M32, Abu Dhabi',
  'M40, ABU DHABI',
  'M40, Abu Dhabi',
  'M6, Abu Dhabi',
  'MADAM',
  'MADAM, SHARJAH',
  'MADAM,DUBAI',
  'MADAM,HABAB',
  'MADINA SAYED, AUH',
  'MADINAT SAYED, ABU DHABI',
  'MADINAT SAYED, AUH',
  'MADINAT SAYED,AUH',
  'MADINAT ZAYED',
  'MADINAT ZAYED, AUH',
  'MADINATH ZAYED',
  'MAFRAQ',
  'MAFRAQ, ABU DHABI',
  'MAFRAQ, AUH',
  'MAHDAM,SHARJAH',
  'MAKHOOLA, AL AIN',
  'MALEEHA',
  'MAMOURAH, RAK',
  'MAMOURAH,RAK',
  'MAMURAH, NAKHEEL',
  'MAMZAR DUBAI',
  'MAMZAR-2 ',
  'MANAMA',
  'MANAMA, RAS AL KHAIMA',
  'MAREER, RAK',
  'MAREES, RAK',
  'MAREES,RAK',
  'MARIED',
  'MARINA',
  'MARITIME CITY',
  'MARKET, ABU DHABI ',
  'MARYS, RAS AL KHAIMA',
  'MASAFI',
  'MAZA SIGNAL, SHARJAH',
  'MB 2, ABU DHABI',
  'MEENA BAZAR',
  'MEENA, ABU DHABI',
  'MERI TIME CITY',
  'MIGRATION BRIDGE ABD, AUH',
  'MIIZAR',
  'MINA STR : ABU DHABI',
  'MIRBA',
  'MIRBAH',
  'MIRDIF',
  'MIZHAR 1',
  'MOHSINA.',
  'MOROCCO,IC',
  'MOROOR ROAD',
  'MOWAHAT 3',
  'MOWAINAT 2',
  'MUHAISINA',
  'MUHAISINAH-2',
  'MURAQQABAD',
  'MURAQQABAT',
  'MUROOR',
  'MUROOR : ABU DHABI',
  'MUROOR ROAD, AUH',
  'MUROOR, ABU DHABI',
  'MUROOR, ABU DHABI ',
  'MUROOR,AUH',
  'MUSAFA 02, AUH',
  'MUSAFA 10, AUH',
  'MUSAFA 13, AUH',
  'MUSAFA 25, AUH',
  'MUSAFA 32, AUH',
  'MUSAFA 36, AUH',
  'MUSAFA 37, AUH',
  'MUSAFA 38, AUH',
  'MUSAFA 40, AUH',
  'MUSAFFA',
  'MUSAFFA - 10',
  'MUSAFFA - 11',
  'MUSAFFA - 15',
  'MUSAFFA - 24',
  'MUSAFFA - 25',
  'MUSAFFA - 32',
  'MUSAFFA - 33',
  'MUSAFFA - 36',
  'MUSAFFA - 37',
  'MUSAFFA - 38',
  'MUSAFFA - 6',
  'MUSAFFA - M5',
  'MUSAFFA - M7',
  'MUSAFFA 03 , AUH',
  'MUSAFFA 06, AUH',
  'MUSAFFA 13, AUH',
  'MUSAFFA 40, AUH',
  'MUSAFFA 42',
  'MUSAFFA 43, AUH',
  'MUSAFFA M - 3',
  'MUSAFFA M:13, AUH',
  'MUSAFFA M:43, AUH',
  'MUSAFFA, AUH',
  'MUSAFFA,32',
  'MUSAFFA,M32',
  'MUSAFFA,M35',
  'MUSAFFA,M36',
  'MUSAFFA,M37',
  'MUSAFFA,M38',
  'MUSAFFA,Z6',
  'MUSAFFA-35',
  'MUSAFFAH',
  'MUSAFFAH 11, AUH',
  'MUSAFFAH 14, AUH',
  'MUSAFFAH 40, AUH',
  'MUSAFFAH M - 14',
  'MUSAFFAH M-26',
  'MUSAFFAH, AUH',
  'MUSAFFAH-M37',
  'MUSHRIF',
  'MUSHRIF, AJMAN',
  'MUSHRIF, AUH',
  'MUSSAFA 16',
  'MUSSAFA 32',
  'MUSSAFA 38',
  'MUSSAFAH 10',
  'MUSSAFAH 37',
  'MUSSAFAH 40',
  'MUSSAFAH, AUH',
  'MUSSAFAH-10',
  'MUSSAFAH-11',
  'MUSSAFAH-26',
  'MUSSAFAH-32',
  'MUSSAFAH-38',
  'MUSSAFAH-42',
  'MUSSAFAH-43',
  'MUSSAFAH-9',
  'MUSSAFAH-M15',
  'MUSSAFAH-M2',
  'MUSSAFAH-M9',
  'MUSSFAH-26',
  'MUSSFAH-32',
  'MUSSFAH-36',
  'MUSSFAH-37',
  'MUSSFAH-5',
  'MUSSFAH-ICAD',
  'MUTEENA',
  'MUTHEENA',
  'MUWAIHAT 3',
  'MUWAILAH',
  'MUWAILAH, SHARJAH',
  'MUWAILEH',
  'MUWAILEH,  SHJ',
  'Meena Bazar, Al Ain',
  'Mowaihat 2',
  'Mowaihat 3',
  'Mustafa Shabiya m-12.Abu dhabi',
  'NABBA, SHARJAH',
  'NADAL HAMAR',
  'NAHADA-1',
  'NAHYAN CMP, AUH',
  'NAHYAN, ABU DHABI',
  'NAHYAN,AUH',
  'NAIF',
  'NAIF, DEIRA',
  'NAIF, DXB',
  'NAIF,DEIRA',
  'NAIF,GOLD SOUQ',
  'NAIF-GOLD SOUQ',
  'NAJDA STR, ABU DHABI',
  'NAJDA STR, AUH',
  'NAJDA STREET',
  'NAJDA STREET, AUH',
  'NAJDA, AUH',
  'NAKEEL 1',
  'NAKHEEL',
  'NAKHEEL (RAK)',
  'NAKHEEL 1',
  'NAKHEEL, AJMAN',
  'NAKHEEL, DEIRA',
  'NAKHEEL, DUBAI',
  'NAKHEEL, DXB',
  'NAKHEEL, NESTO ',
  'NAKHEEL, RAK',
  'NAKHEEL,DEIRA',
  'NAKHEEL,RAK',
  'NAKHEEL-01',
  'NAKHEEL-1',
  'NAKHEEL-2',
  'NAMDAN, AUH',
  'NATIONAL PAINTS, SHARJAH',
  'NAVY GATE, ABU DHABI',
  'NAVY GATE, AUH',
  'NDJDNDMD',
  'NEAR NESTO (RAK)',
  'NEAR NESTO, RAK',
  'NEW IND, UAQ',
  'NEW SANAYA UAQ',
  'NEW SANAYA, UAQ',
  'NEW SANAYA-UAQ',
  'NEW SATWA',
  'NEW SHABIYA, ABU DHABI',
  'NEW SHAHAMA',
  'NUAIMEYA',
  'NUAIMEYA 1',
  'NUAIMEYA 2',
  'NUAIMEYA,2',
  'NUAIMEYA-2',
  'NUAIMEYA-3',
  'NUAIMIA , AJMAN',
  'NUAIMIYA, AJM',
  'Noida',
  'Nuaimeya 2',
  'Nuaimeya2',
  'OFFICE',
  'OLD AIRPORT ROAD, ABU DHABI',
  'OLD RAK',
  'OLD RAK,RAK',
  'OMAN',
  'OPP BURJMAN METRO',
  'OUD METHA',
  'Office',
  'Oman',
  'PASSPORT ROAD, AUH',
  'PERSIA, IC',
  'PERSIA,IC',
  'PHASE-2,IC',
  'PORT SAED',
  'PORT SAEED',
  'QASIMIA',
  'QATAR',
  'QUSAIS',
  'QUSAIS 3',
  'QUSAIS DAMASCUS',
  'QUSAIS ETISALAT',
  'QUSAIS IND 4',
  'QUSAIS LULU',
  'QUSAIS SHEIKH COLONY',
  'QUSAIS- 01',
  'QUSSAIDAT, RAK',
  'R A K',
  'RAFFA, RAK',
  'RAK',
  'RAK NEAR NESTO',
  'RAK, FAIZAL STREET',
  'RAK, JULAN',
  'RAK, MOWAIHAT - 2',
  'RAK,MAMORAH',
  'RAK,MARES',
  'RAK- AL RAFFA',
  'RAMS , RAS AL KHAIMA',
  'RAMS ROAD, RAK',
  'RAMS, RAK',
  'RAMS,RAK',
  'RAMS-RAK',
  'RAS AL CHOR',
  'RAS AL KHAIMA',
  'RAS AL KHAIMA, ADAN',
  'RAS AL KHAIMA, AL DAHAN',
  'RAS AL KHAIMA, AL JAZEERA',
  'RAS AL KHAIMA, DAHAN',
  'RAS AL KHAIMA, DHAHAN',
  'RAS AL KHAIMA, FISH MARKET',
  'RAS AL KHAIMA, JULAN',
  'RAS AL KHAIMA, MONOOR',
  'RAS AL KHAIMA, NAKHEEL',
  'RAS AL KHAIMA, RAMS',
  'RAS AL KHOR',
  'RAS Al-KHAIMAH',
  'RAS Al-KHAIMAH, JULAN',
  'RASAL KHAIMA OLD, RAK',
  'RASALKAIMHA',
  'RASHIDEYA 3',
  'RASHIDEYA1',
  'RASHIDIYA',
  'RASHIDIYA - 2',
  'RASHIDIYA - 2, AJMAN',
  'RASHIDIYA - 3, AJMAN',
  'RASHIDIYA, AJMAN',
  'RASHIDIYA-02',
  'RASHIDIYA-03',
  'RASIDIYA IND AREA',
  'RAWDHA 2',
  'RAWDHA 3',
  'RAWDHA, AJMAN',
  'RAZEEN, AUH',
  'RAZIN',
  'REVERA DREAM,IC',
  'RIFFA, RAK',
  'RIGGA',
  'RIGGA ROAD',
  'ROLLA',
  'ROLLA SHARJAH',
  'ROLLA,SHARJAH',
  'ROUL DIBBA',
  'ROWDA - 2',
  'RTA BUS STATION-RAK',
  'RUMAILA 1',
  'RUMAILA 2',
  'RUMAILA,01',
  'RUMAILA,02',
  'RUMAILA,1',
  'RUMAILA,1 AJMAN',
  'RUMAILA-1',
  'RUMAILA-2',
  'RUMALA-1, AJMAN ',
  'RUMILA,KARAMA',
  'RUSSIA,IC',
  'Ras Al Khor Ind. Second, Dubai',
  'Rashideya1',
  'Rashidiya',
  'Rawdha 3',
  'Razeen- 3, AUH',
  'Razeen- 4, AUH',
  'Rolla',
  'S.DHAIT',
  'SAAJAH-SHARJAH',
  'SABIYA - 10',
  'SABKA',
  'SABKHA',
  'SAJA, SHARJAH',
  'SAJA-SHARJHA',
  'SAJJA',
  'SAKAMKAM',
  'SAKMKAM',
  'SALAH AL DIN',
  'SALAHALDIN',
  'SALAHUDDIN',
  'SALAM STR, ABU DHABI',
  'SALAM STREET, AUH',
  'SALAMSIR, AUH',
  'SAMARI RESIDENCE, WASL',
  'SAMARY RESIDENCE',
  'SANAIYA, AJMAN',
  'SANAIYA, AL AIN',
  'SANAYA',
  'SANAYA ,AL AIN',
  'SANAYA AL AIN',
  'SANAYA, AJM',
  'SANAYA, UAQ',
  'SANAYA-11',
  'SANAYYA-2',
  'SAS AL NAKHEEL',
  'SATWA',
  'SATWA ',
  'SATWA BUR DUBAI',
  'SEA PORT,FUJAIRAH',
  'SEE COM',
  'SEWHN',
  'SHAAM,RAK',
  'SHABIA  ME 11',
  'SHABIA : 10, AUH',
  'SHABIA : 19',
  'SHABIA,11',
  'SHABIA,M-10',
  'SHABIA,ME11',
  'SHABIA,ME12',
  'SHABIA-11',
  'SHABIA:10, AUH',
  'SHABIYA',
  'SHABIYA  -10',
  'SHABIYA - 10',
  'SHABIYA - 10, ABU DHABI',
  'SHABIYA - 11',
  'SHABIYA - 11, AUH',
  'SHABIYA - 12',
  'SHABIYA - 9',
  'SHABIYA M-10',
  'SHABIYA M9',
  'SHABIYA ME 10',
  'SHABIYA ME-10',
  'SHABIYA ME-9',
  'SHABIYA, ME - 11',
  'SHABIYA-10',
  'SHABIYA-12',
  'SHABIYA-9',
  'SHABIYA-M9',
  'SHAHAMA, AUH',
  'SHAHJAH, ROLLA',
  'SHAIK COLONY-QUSAIS',
  'SHAM, RAS AL-KHAIMAH',
  'SHAM,RAK',
  'SHAM-RAK',
  'SHAMAL, RAK',
  'SHAMAL, RAS AL KHAIMA',
  'SHAMAL,RAK',
  'SHAMS LAHAB',
  'SHARAF DG',
  'SHARAM',
  'SHARIKAT AL AIN',
  'SHARIKAT, AL AIN',
  'SHARIKATH, AL AIN',
  'SHARJAH',
  'SHARJAH - 1',
  'SHARJAH AL MAHATTA',
  'SHARJAH IND 1',
  'SHARJAH IND 10',
  'SHARJAH IND 12',
  'SHARJAH IND 13',
  'SHARJAH IND 15',
  'SHARJAH IND 17',
  'SHARJAH IND 2',
  'SHARJAH IND-01',
  'SHARJAH IND-02',
  'SHARJAH IND-05',
  'SHARJAH IND-10',
  'SHARJAH IND-12',
  'SHARJAH IND-15',
  'SHARJAH IND-17',
  'SHARJAH INDUSTRIAL -13',
  'SHARJAH MAJAZ - 1',
  'SHARJAH MUWAILAH',
  'SHARJAH MUWALIA',
  'SHARJAH ROLLA',
  'SHARJAH, ABU SHAGARA',
  'SHARJAH, AL GHUWAIR',
  'SHARJAH, AL MAMZAR',
  'SHARJAH, AL MAREIJA',
  'SHARJAH, AL NABBA',
  'SHARJAH, AL NABBHA',
  'SHARJAH, AL TAAWUN',
  'SHARJAH, AL YARMOK',
  'SHARJAH, BU SHAGARA',
  'SHARJAH, BUTEENA',
  'SHARJAH, CATHOLIC CHURCH',
  'SHARJAH, DHAND',
  'SHARJAH, HELIO - 2',
  'SHARJAH, IND',
  'SHARJAH, IND - 3',
  'SHARJAH, IND - 5',
  'SHARJAH, IND - 8',
  'SHARJAH, IND - 9',
  'SHARJAH, IND : 3',
  'SHARJAH, IND-1',
  'SHARJAH, IND-10',
  'SHARJAH, IND-17',
  'SHARJAH, IND-5',
  'SHARJAH, INDUSTRIAL - 1',
  'SHARJAH, INDUSTRIAL - 10',
  'SHARJAH, INDUSTRIAL - 16',
  'SHARJAH, INDUSTRIAL - 17',
  'SHARJAH, INDUSTRIAL - 2',
  'SHARJAH, INDUSTRIAL - 4',
  'SHARJAH, INDUSTRIAL - 6',
  'SHARJAH, INDUSTRIAL 10',
  'SHARJAH, INDUSTRIAL 13',
  'SHARJAH, JAZZAT',
  'SHARJAH, MAJAZ',
  'SHARJAH, MAJAZ - 1',
  'SHARJAH, MAJAZ - 2',
  'SHARJAH, MAJAZ - 3',
  'SHARJAH, MEGA MALL',
  'SHARJAH, MUSALLA',
  'SHARJAH, MUSSALLA',
  'SHARJAH, MUWAILEH',
  'SHARJAH, NABBA',
  'SHARJAH, NAHDA',
  'SHARJAH, NATIONAL PAINTS',
  'SHARJAH, ROLLA',
  'SHARJAH, SAJAA',
  'SHARJAH, STADIUM',
  'SHARJAH, SULAIMAN CHOWK',
  'SHARJAH, UM ALTARAFA',
  'SHARJAH,ABU SHAGARA',
  'SHARJAH,ABU SHAGHARA',
  'SHARJAH,ABU-SHAGARA',
  'SHARJAH,AL NAHDA',
  'SHARJAH,AL-NAHDA',
  'SHARJAH,INDUSTRIAL-13',
  'SHARJAH,NATIONAL PAINT',
  'SHARJAH,NMC',
  'SHARJAH,QASIMIA',
  'SHARJAH,ROLLA',
  'SHARJAH,SAJAA',
  'SHARJAH-ABU SHAGAM',
  'SHARJAH-AL BUTEENA',
  'SHARJAH-AL TAAWUN',
  'SHARJAH-INT',
  'SHARJAH-MAJUS',
  'SHARJAH-MUSALLA',
  'SHARJAH-MUWAILEH',
  'SHARJAH-MUWAILEH ',
  'SHARJAH-NMC',
  'SHARJAH-ROLLA',
  'SHARJAH-SAJAA',
  'SHARJAH-TAWANU',
  'SHERIKATH',
  'SHJ-BIN LADAN ',
  'SHJ-MOWAILEH',
  'SHRJAH,MUWAILIA',
  'SIDROH, RAK',
  'SONAPUR',
  'SOUTH DHAIT, RAK',
  'SOUTH DHAIT,RAK',
  'SOUTH OHAITH,RAK',
  'SOUTH-DHAIT-RAK',
  'SPAIN,IC',
  'SPAIN,IC ',
  'STADIUM SHARJAH',
  'SUBARU',
  'SUHARA',
  'SUWAN, RAK',
  'SWEHAN',
  'SWIHAN',
  'Shabiya 10',
  'Sharikat, Al Ain',
  'Sharja',
  'Sharjah',
  'Sharjah IND-02',
  'Sharjah IND-03',
  'Sharjah IND-10',
  'Sharjah Muweila',
  'Sharjah Rolla',
  'Sonapur',
  'T COM',
  'THOUBAAN, FUJAIRAH',
  'THOUBAN',
  'THOUBAN, RAK',
  'THOUBAN-FJH',
  'THOUBAN-FUJ',
  'THOUBAN-SHARJHA',
  'TOURIST CLUB, ABU DHABI',
  'TOURIST CLUB, AUH',
  'TOURIST,CLUB',
  'TOWN CENTER, AL AIN',
  'TRADE CENTER 1',
  'Town Center, AA',
  'Town Center, Al Ain',
  'U A Q',
  'UAQ',
  'UAQ MARKET',
  'UAQ RAFFA',
  'UAQ,',
  'UAQ,INDUSTRIAL AREA',
  'UMM AL QUWAIN',
  'UMM RAMOOL',
  'UMMAL QUWAIN',
  'UNION',
  'Umm Ramool',
  'Ummu Ramool',
  'WADI KUB, RAK',
  'WARQA',
  'WARSAN',
  'WARSAN, DUBAI',
  'WASSAN -2, DUBAI',
  'WUHAIDA,ABU-HAIL',
  'Wadi Al Ain 1, Al Ain',
  'ZABEEL, DUBAI',
  'ZAITH',
  'ZAKHER',
  'ZAYANI',
  'ZIANI ZONE 1, AUH',
  'ZUBARA',
  'abudabi',
  'al fahidi',
  'aweer',
  'burdubai',
  'calicut',
  'deira',
  'dubai',
  'duplicate',
  'ind',
  'jhjib',
  'office',
  'sgfdsgds',
  'shabbia m9 Abu Dhabi',
  'العراس, العين'
];

export const DEFAULT_AREASLIST = AREASLIST;
export default AREASLIST;
